// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3f49b6c0","667":"153c063b","977":"dae14b4c"}[chunkId] + ".chunk.js";
};